import Dexie from 'dexie';

export const db = new Dexie('files');
// FOR ANYONE WHO WANTS TO MODIFY THE DATABASE STRUCTURE, MAKE SURE TO USE Version.upgrade()
// https://dexie.org/docs/Version/Version.upgrade()
db.version(1).stores({
  offlineImage: 'key, downloaded, downloading',
});